import { render, staticRenderFns } from "./ThirdSection.vue?vue&type=template&id=ab9b9490&scoped=true&"
import script from "./ThirdSection.vue?vue&type=script&lang=js&"
export * from "./ThirdSection.vue?vue&type=script&lang=js&"
import style0 from "./ThirdSection.vue?vue&type=style&index=0&id=ab9b9490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9b9490",
  null
  
)

export default component.exports